export function Stat({
  label,
  value,
  tone = 'txt',
}: {
  label: string;
  value: string;
  tone?: 'txt' | 'amber' | 'cyan' | 'green' | 'red' | 'dim';
}) {
  const color = {
    txt: 'text-txt',
    amber: 'text-amber',
    cyan: 'text-cyan',
    green: 'text-green',
    red: 'text-red',
    dim: 'text-dim',
  }[tone];
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[9px] uppercase tracking-[0.12em] text-dim">{label}</span>
      <span className={`tabular text-[15px] ${color}`}>{value}</span>
    </div>
  );
}
